import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";

export const Route = createFileRoute("/admin/newsletter")({
  component: () => (
    <ProtectedRoute>
      <AdminNewsletter />
    </ProtectedRoute>
  ),
});
